
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_61574_22710)","fill":"#4A4A4A"}},[_c('path',{attrs:{"d":"M15 7.25l.077.004a.75.75 0 010 1.492L15 8.75H1a.75.75 0 010-1.5h14z"}}),_c('path',{attrs:{"d":"M14.25 8a6.25 6.25 0 10-12.5 0 6.25 6.25 0 0012.5 0zm1.5 0A7.75 7.75 0 11.25 8a7.75 7.75 0 0115.5 0z"}}),_c('path',{attrs:{"d":"M10.25 8c0-2.164-.694-3.776-1.38-4.845A7.9 7.9 0 008 2.035a7.9 7.9 0 00-.87 1.12C6.445 4.225 5.75 5.835 5.75 8c0 2.164.694 3.776 1.38 4.845.313.486.626.858.87 1.119a7.89 7.89 0 00.87-1.12c.686-1.068 1.38-2.68 1.38-4.844zm1.5 0c0 2.502-.806 4.39-1.62 5.655a9.353 9.353 0 01-1.121 1.428 6.94 6.94 0 01-.496.467l-.034.028-.016.012-.002.002a.75.75 0 01-.815.07l-.107-.07-.002-.002-.016-.012-.034-.028a6.94 6.94 0 01-.496-.467 9.35 9.35 0 01-1.122-1.428C5.056 12.391 4.25 10.502 4.25 8c0-2.502.806-4.39 1.62-5.655A9.353 9.353 0 016.99.917 6.93 6.93 0 017.487.45l.034-.028.016-.012.002-.002.107-.07a.751.751 0 01.815.07l.002.002.016.012.034.028.114.099c.095.084.227.207.382.368.31.321.716.797 1.122 1.428C10.944 3.609 11.75 5.498 11.75 8z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_61574_22710"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    